import React from 'react'
import PropTypes from 'prop-types'
import { i18nTranslate } from 'src/utils'
import { VscClose as CloseIcon } from 'react-icons/vsc'
import { Button, Col, ListGroup, Row } from 'react-bootstrap'
import { IS_BROWSER } from 'config/appConfig'
import { application } from 'src/utils'
import { signInwithRedirect, signOutWithRedirect } from 'src/utils/signInUtils'
import { LocaleModal, mobileMenuState } from 'src/views/components'
import { customerContainer } from 'src/models'
import NuskinAccountIcon from 'src/views/components/Header/Components/UserMenu/NuskinAccountIcon'
import nuskinLogoMobile from 'src/images/live-event-nuskin-mobile-logo.png'
import { observer } from 'mobx-react'
import { enableNewFeature } from 'src/utils/commonUtils'
import { MobileMenuCategories } from '../NuskinHeader/MobileMenuNuskin/MobileMenuCategories'
import './styles.scss'

/**
 * MobileSignout component that renders the sign out button
 * in the mobile menu for authenticated users.
 * Extends React.Component.
 */
/**
 * MobileSignout component that renders the sign out button
 * in the mobile menu for authenticated users.
 * Extends React.Component.
 */
class MobileSignout extends React.Component {
  nameSpace = 'ssr-resource'
  /**
   * Toggles the mobile menu visibility when the screen size is tablet or smaller.
   */
  handleMobileMenu = () => {
    if (application.isTabletOrSmaller) {
      mobileMenuState.toggleMenuVisibility()
    }
  }

  render() {
    if (!IS_BROWSER) {
      return <></>
    }

    const componentToRender = customerContainer.isRegisterUser ? (
      <div
        className={`${
          enableNewFeature('enableNewHeaderNavigation')
            ? 'nu-mob-signout new-nu-mob-signout'
            : 'nu-mob-signout'
        }`}>
        <Button className="nu-mob-signout-btn" onClick={signOutWithRedirect}>
          {i18nTranslate('header.signOut', 'Sign Out', {
            nameSpace: this.nameSpace,
          })}
        </Button>
      </div>
    ) : (
      <div
        className={`${
          enableNewFeature('enableNewHeaderNavigation')
            ? 'nu-mob-signout new-nu-mob-signout'
            : 'nu-mob-signout'
        }`}>
        <Button
          className={`nu-mob-signout-btn`}
          onClick={signInwithRedirect}
          data-testid="qa-signin">
          <NuskinAccountIcon
            className="mr-1"
            style={{ fontSize: '24px', verticalAlign: 'middle' }}
            aria-label="sign in icon"
          />
          {i18nTranslate('header.signIn', 'Sign In', {
            nameSpace: this.nameSpace,
          })}
        </Button>
      </div>
    )
    return componentToRender
  }
}

@observer
class EventMobileMenu extends React.Component {
  nameSpace = 'ssr-resource'

  constructor(props) {
    super(props)
    this.mobileMenuRef = null
  }

  componentDidMount() {
    document?.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document?.removeEventListener('mousedown', this.handleClickOutside)
    this.mobileMenuRef = null
  }

  handleClickOutside = event => {
    if (
      this.mobileMenuRef &&
      !this.mobileMenuRef?.contains(event?.target) &&
      mobileMenuState?.isMenuVisible
    ) {
      mobileMenuState?.toggleMenuVisibility()
    }
  }

  handleMenuToggle = () => {
    mobileMenuState.toggleMenuVisibility()
  }

  handleLinkClick = () => {
    mobileMenuState.toggleMenuVisibility()
  }

  getCachedCategories = () => {
    const navigationData = this.props?.navigationData || {}
    if (navigationData?.categories && navigationData.categories.length > 0) {
      return navigationData.categories
    }
    return []
  }

  myFirstName = text => {
    let rtext = ''
    let len = String(text).length
    if (len > 12) {
      rtext = String(text).slice(0, 11).concat('...')
    } else {
      rtext = text
    }
    return ' ' + rtext
  }

  render() {
    const isMenuVisible = mobileMenuState?.isMenuVisible
    const categoriesFromMenu = this.getCachedCategories()
    const isNewHeaderEnabled =
      enableNewFeature('enableNewHeaderNavigation') ||
      enableNewFeature('enableRedesignMarketSelector') ||
      enableNewFeature('enableRedesignMainMenu')
    const openOrClosed = mobileMenuState.isMenuVisible ? 'open' : 'closed'

    return (
      <div className={isNewHeaderEnabled ? 'redesign-main-menu' : ''}>
        {enableNewFeature('enableNewHeaderNavigation') && isMenuVisible && (
          <div
            className="mobile-menu-overlay"
            onClick={this.handleMenuToggle}
          />
        )}
        <aside
          ref={
            enableNewFeature('enableNewHeaderNavigation')
              ? mobileMenuRef => (this.mobileMenuRef = mobileMenuRef)
              : null
          }
          className={
            enableNewFeature('enableNewHeaderNavigation')
              ? `eventheader-mobilemenu hide-on-desktop pancake new-pancake fixed-top nu-mobilemenu new-nu-mobilemenu ${openOrClosed}`
              : `eventheader-mobilemenu hide-on-desktop pancake fixed-top h-100 w-100 bg-white nu-mobilemenu ${openOrClosed}`
          }>
          <div
            className={`eventheader-mobilemenu-header ${
              enableNewFeature('enableNewHeaderNavigation')
                ? 'new-nu-mobilemenu-header'
                : ''
            }`}>
            <Row className="w-100 h-100" noGutters>
              <Col xs={9} className="d-flex">
                <div className="eventheader-mobileeventlogo">
                  <img
                    className="eventheader-mobileeventlogo-img"
                    src={nuskinLogoMobile}
                  />
                </div>
                {customerContainer.isRegisterUser && (
                  <span className={`ml-3 m-auto nu-sign-text`}>
                    {i18nTranslate('header.welcome', 'Hi', {
                      nameSpace: this.nameSpace,
                    })}
                    {this.myFirstName(
                      customerContainer.profileResponse.firstName
                    )}
                  </span>
                )}
              </Col>
              <Col xs={3} className="text-right">
                <Button
                  className="eventheader-mobilemenu-close"
                  aria-label="closebutton"
                  variant="none"
                  onClick={this.handleLinkClick}>
                  <CloseIcon size="24px" />
                </Button>
              </Col>
            </Row>
          </div>

          <div
            className={`eventheader-mobilemenu-container ${
              enableNewFeature('enableNewHeaderNavigation')
                ? 'new-mobile-menu-container'
                : ''
            }`}>
            <MobileMenuCategories
              {...(enableNewFeature('enableRedesignMainMenu')
                ? {
                    categories: categoriesFromMenu,
                    navigationData: this.props.navigationData,
                    currentCategoryPath: ['category'],
                  }
                : {
                    ...this.props,
                    currentCategoryPath: ['category'],
                  })}
            />
            {!enableNewFeature('enableRedesignMarketSelector') && (
              <ListGroup className="nu-mobilemenu-link-list">
                <ListGroup.Item>
                  <LocaleModal history={this.props.history} isNuskinHeader />
                </ListGroup.Item>
              </ListGroup>
            )}
          </div>
          <MobileSignout enableLiveEvent={this.props.enableLiveEvent} />
        </aside>
      </div>
    )
  }
}

EventMobileMenu.propTypes = {
  navigationData: PropTypes.object,
}

export default EventMobileMenu
export { EventMobileMenu }
